import { getCashbackParams } from './brand.helpers'
import { isEuropeanCountry } from './country.helpers'
import { CURRENCIES } from './staking/staking.helpers'

const CASHBACK_PER_VALUE = 10

const objectHasTrueValue = (obj) => {
  return Object.values(obj).some((value) => value === true)
}

const createCashbackTrackingUrl = (url, authId) => {
  return `${url}${authId}${getCashbackParams()}`
}

const displayCashbackValue = (
  { value, format },
  { onramp, cashbackCurrency }
) => {
  if (format === '%') {
    return {
      label: 'cashback.get-up-to-back',
      value: Math.floor(calculatePerUnitCurrency(value, onramp)),
      currency: cashbackCurrency
    }
  }
  return {
    label: 'cashback.get-flat-back',
    value: Math.floor(parseFloat(value) / onramp),
    currency: cashbackCurrency
  }
}

const calculatePerUnitCurrency = (percentage, onramp) => {
  const formattedPercentage = parseFloat(percentage)
  if (formattedPercentage <= 0) return 1
  const perUnit = formattedPercentage / 100 / onramp
  return Math.max(1, perUnit * CASHBACK_PER_VALUE)
}

const buildCurrencyByRegion = (region) => {
  if (region === 'CHE') {
    return CURRENCIES.CHF
  } else if (region && isEuropeanCountry(region)) {
    return CURRENCIES.EUR
  }
  return CURRENCIES.USD
}

export {
  objectHasTrueValue,
  createCashbackTrackingUrl,
  displayCashbackValue,
  buildCurrencyByRegion,
  CASHBACK_PER_VALUE
}
